/** "1 day", "30 days". */
const days = (n: number) => `${n} ${n === 1 ? "day" : "days"}`;

/** User-facing copy for "Who has Account Plans" (Izba Admin → Config → Account Plans). */
export const A = {
  title: "Who has Account Plans",
  subtitle: (seconds: number) =>
    `Account Plans is off for every organization until you turn it on here. Turning it off hides Account Plans everywhere in that organization and refuses its pages within about ${seconds} seconds; its plans and briefings are kept and come back when you turn it on again.`,
  killEnv:
    "The kill switch is set on the server (ACCOUNT_PLANS_KILL_SWITCH), so Account Plans is off for every organization whatever is set below.",
  killRuntime:
    "The kill switch is on in the admin console, so Account Plans is off for every organization whatever is set below.",
  loading: "Loading…",
  retry: "Retry",
  colOrg: "Organization",
  colStatus: "Account Plans",
  colStatusHint: "The whole feature for this organization",
  colLastChange: "Last change",
  inactive: "Inactive organization",
  on: "On",
  off: "Off",
  followsDefault: "Default (never set here)",
  neverChanged: "Never changed here",
  lastChange: (
    what: "plans" | "chat",
    enabled: boolean,
    by: string,
    when: string
  ) =>
    `${what === "chat" ? "Plan chat" : "Account Plans"} turned ${
      enabled ? "on" : "off"
    } by ${by}${when ? `, ${when}` : ""}`,
  confirmGroup: (name: string) => `Confirm the change for ${name}`,
  confirmOn: (name: string, chat: boolean) =>
    `Turn on Account Plans for ${name}? Its users with access will see Account Plans within about a minute. Plan chat will be ${
      chat ? "on" : "off"
    }.`,
  confirmOff: (name: string, plans: number) =>
    `Turn off Account Plans for ${name}? Everyone there stops seeing it, sponsors included. ${
      plans
        ? `Its ${plans} plan version${plans === 1 ? "" : "s"} and briefings are kept`
        : "Nothing is deleted"
    } and come back when you turn it on again.`,
  confirmOnButton: (name: string) => `Yes, turn on Account Plans for ${name}`,
  confirmOffButton: (name: string) => `Yes, turn off Account Plans for ${name}`,
  noteLabel: "Note",
  notePlaceholder: "Why (optional, kept in its history)",
  cancel: "Cancel",
  colChat: "Plan chat",
  colChatHint: "“Ask about this plan” inside Account Plans",
  plansSwitch: (name: string) => `Account Plans for ${name}`,
  chatSwitch: (name: string) => `Plan chat for ${name}`,
  planVersions: (n: number) => `${n} plan version${n === 1 ? "" : "s"}`,
  chatNeedsPlans: "Turn on Account Plans first",
  chatConfirmOn: (name: string, plansOn: boolean) =>
    `Turn on plan chat ("Ask about this plan") for ${name}? ${
      plansOn
        ? "Everyone who can open a plan there can ask about it within about a minute."
        : "It shows once Account Plans is turned on there."
    }`,
  chatConfirmOff: (name: string) =>
    `Turn off plan chat for ${name}? "Ask about this plan" disappears from every plan there; past chats are kept.`,
  chatConfirmOnButton: (name: string) => `Yes, turn on plan chat for ${name}`,
  chatConfirmOffButton: (name: string) => `Yes, turn off plan chat for ${name}`,
  colRefresh: "Plan refresh",
  colRefreshHint: "How often each account's plan should be republished",
  refreshLabel: "Plan refresh: every",
  refreshDaysUnit: "days",
  refreshSelect: (name: string) => `Plan refresh for ${name}, in days`,
  // "every 1 day", never "every 1 days" (F-UF-E09).
  refreshConfirm: (name: string, from: number, to: number) =>
    `Change the plan refresh for ${name} from every ${days(from)} to every ${days(to)}? Account owners there are asked to republish a plan ${days(to)} after it was last published, and overdue plans get a bell.`,
  refreshConfirmButton: (name: string, to: number) =>
    `Yes, set plan refresh to every ${days(to)} for ${name}`,
  // How long an upload with a problem is kept (failure audit Q3; clean reads waiting
  // on Confirm plan never expire, 2026-10-31).
  keepLabel: "Keep unused uploads:",
  keepSelect: (name: string) => `Keep unused uploads for ${name}, in days`,
  keepHint:
    "Refused, couldn't be read, stopped by a check, or discarded. Deleted after this many days.",
  keepConfirm: (name: string, from: number, to: number) =>
    `Change how long ${name} keeps unused uploads from ${days(from)} to ${days(to)}? An upload with a problem (refused, couldn't be read, stopped by a check, or discarded) is deleted ${days(to)} after it arrived, with its stored file and what was read.`,
  keepConfirmButton: (name: string, to: number) =>
    `Yes, keep unused uploads for ${days(to)} for ${name}`,
  checkNow: "Check now",
  checkNowLabel: (name: string) => `Check plan refreshes for ${name} now`,
  checking: "Checking…",
  checkResult: (checked: number, overdue: string[], notified: number): string =>
    [
      `${checked} account${checked === 1 ? "" : "s"} checked`,
      overdue.length
        ? `${overdue.length} overdue: ${overdue.join(", ")}`
        : "none overdue",
      `${notified} bell${notified === 1 ? "" : "s"} sent`,
    ].join(" · "),
  overdueAccount: (
    name: string,
    version: number,
    published: string,
    due: string
  ) =>
    `${name} (v${version}${published ? `, published ${published}` : ""}${
      due ? `, due ${due}` : ""
    })`,
};
